import { IconPicker, IconPickerProps } from '@makyoapp/makyo-tw-ui'

export type CompIconPickerProps = IconPickerProps

export const CompIconPickerCore = (props: CompIconPickerProps) => {
  return <IconPicker {...props} />
}
